import React from 'react';
import { Accordion, AccordionSummary, AccordionDetails, Box, Typography, Slider } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

interface GenerationParamsProps {
  steps: number;
  cfgScale: number;
  clipSkip: number;
  onChange: (key: string, value: number) => void;
}

export const GenerationParams: React.FC<GenerationParamsProps> = ({ steps, cfgScale, clipSkip, onChange }) => (
  <Accordion sx={{ mb: 2 }}>
    <AccordionSummary expandIcon={<ExpandMoreIcon />}>
      <Typography>Steps / Guidance / Clip Skip</Typography>
    </AccordionSummary>
    <AccordionDetails>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
        <Typography>Steps: {steps}</Typography>
        <Slider value={steps} min={1} max={100} step={1} onChange={(_, val) => onChange('steps', val as number)} />

        <Typography>Guidance (CFG Scale): {cfgScale}</Typography>
        <Slider value={cfgScale} min={1} max={20} step={0.1} onChange={(_, val) => onChange('cfgScale', val as number)} />

        <Typography>Clip Skip: {clipSkip}</Typography>
        <Slider value={clipSkip} min={1} max={12} step={1} onChange={(_, val) => onChange('clipSkip', val as number)} />
      </Box>
    </AccordionDetails>
  </Accordion>
);
